import { api } from 'utility';
import {
  getCRUImprestUrl,
  getCarTableListUrl,
  getCartableRequestListsUrl,
  getCreateFunderUrl,
  getCreditUrl,
  getBounesCardRequstUrl,
  getBounesCardIssuanceRequestUrl,
  getSecondaryCardIssuanceRequesUrl,
  getBlockCardRequestUrl,
  getRequestCardIssuanceForThingUrl,
  getActiveCardRequestMessageUrl,
  getActiveCardRequestUrl,
  getPhysicalCardIssuanceRequest2Url,
  getUserInfo
} from 'URLs';
class Services {
  /**
   * لیست حساب های چند امضایی
   */
  getCarTableList(params) {
    return api.post(getCarTableListUrl(), params).then((res) => res.data);
  }
  /**
   * لیست درخواست ها
   */
  getCartableRequestList(params) {
    return api.get(getCartableRequestListsUrl(), { params }).then((res) => res.data);
  }

  getCredit() {
    return api.get(getCreditUrl()).then((res) => res.data.result);
  }
  /**
   * لیست بن کارت ها
   */
  getListCart(params) {
    return api.get(getBounesCardRequstUrl(), { params }).then((res) => res.data);
  }
  /**
   * درخواست صدور کارت
   */
  requestCardIssuance(params) {
    return api.post(getBounesCardIssuanceRequestUrl(), params).then((res) => res.data);
  }
  /**
   * درخواست صدور کارت اگر تایپ انتخابی تنخواه دار باشد
   */
  requestCardIssuanceForThing(params) {
    return api.post(getRequestCardIssuanceForThingUrl(), params).then((res) => res.data);
  }
  /**
   * دریافت تنخواه دار
   */
  getFunder(params) {
    return api.get(getCreateFunderUrl(), { params }).then((res) => res.data);
  }
  /**
   * دریافت شعبه
   */
  getBranch(params) {
    return api.get(getCRUImprestUrl(), { params }).then((res) => res.data);
  }
  /**
   * درخواست المثنی
   */
  requestSecondaryCardIssuance(params) {
    return api.post(getSecondaryCardIssuanceRequesUrl(), params).then((res) => res.data);
  }
  /**
   * درخواست مسدودی
   */
  blockCard(cardnumber) {
    return api.post(getBlockCardRequestUrl(cardnumber)).then((res) => res.data);
  }

  /**
   * درخواست چاپ فیزیکی
   */
  requestPhysicalCardIssuance(params) {
    return api.post(getPhysicalCardIssuanceRequest2Url(), params).then((res) => res.data);
  }
  /**
   * دریافت اطلاعات کاربر با یوزر نیم در قسمت چاپ فیزیکی 
   */
  getuserInfo(params) {
    return api.get(getUserInfo(), { params }).then((res) => res.data);
  }

  /**
   * درخواست فعال سازی کارت... پیامک ارسال میشود
   */
  requestSendMessageAcitveCart(params) {
    return api.post(getActiveCardRequestMessageUrl(), params).then((res) => res.data);
  }
  /**
   * فعال سازی کارت
   */
  requestAcitveCart(params) {
    return api.post(getActiveCardRequestUrl(), params).then((res) => res.data);
  }
}

export default new Services();
